import "./ContentPage.css";

function ContentPage({ children }) {
  return <div className="ContentPage">{children}</div>;
}

export default ContentPage;
